import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const SupplierViewModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=rEoYlfTmXy0&ab_channel=apadua" />
);

export default SupplierViewModal;
